import React from 'react'
import { Switch, Route } from 'react-router-dom'
import EventRegister from './EventRegister'
import RegistrationEdit from './RegistrationEdit'
import RegistrationPreview from './RegistrationPreview'
import RegistrationPayment from './RegistrationPayment'
import Registration from './Registration'

const EventRegistration = () => (
  <Switch>
    <Route exact path="/events/:eventSlug/register" component={EventRegister} />
    <Route exact path="/events/:eventSlug/private" render={props => <EventRegister {...props} showHiddenTypes />} />
    <Route exact path="/reg/:id/edit" component={RegistrationEdit} />
    <Route exact path="/reg/:id/preview" component={RegistrationPreview} />
    <Route exact path="/reg/:id/pay" component={RegistrationPayment} />
    <Route exact path="/reg/:id" component={Registration} />
  </Switch>
)

export default EventRegistration



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/EventRegistration.js